/* eslint-disable */
import bi1_data_validation from '../../base_i1_datavalidation'
import { RC, CR, AJRS } from '../../base_i2_success_codes'
import base_i3_log from '../../base_i3_logging'
import { ajax } from 'noquery-ajax'

function unlinkNotificationGroupRuleFromObject(firebase_email, firebase_token, user_id, ngp_uid, rule_uid, object_uid, attribute_uid) {
    return new Promise(function (resolve, reject) {
        var return_msg = "";
        var debug_data = [];
        var call_result = {};
        var task_id = "p2s9t8unlinkNotificationGroupRuleFromObject";
        var response_data = {};

        ///// input validation
        call_result = bi1_data_validation.is_email_address(firebase_email);
        debug_data.push(call_result);
        call_result = bi1_data_validation.is_string(firebase_token);
        debug_data.push(call_result);
        call_result = bi1_data_validation.is_object_uid(object_uid);
        debug_data.push(call_result);
        call_result = bi1_data_validation.is_object_attribute_uid(attribute_uid);
        debug_data.push(call_result);
        call_result = bi1_data_validation.is_ngp_uid(ngp_uid);
        debug_data.push(call_result);
        call_result = bi1_data_validation.is_string(rule_uid);
        debug_data.push(call_result);
        call_result = bi1_data_validation.is_string_number(user_id);
        debug_data.push(call_result);

        var validation_failed_flag = false;
        for (var index in debug_data) {
          if (debug_data[index][CR.success] != RC.success) {
            validation_failed_flag = true;
            break;
          }
        }

        if (validation_failed_flag == true) {
          return_msg += "input validation failed";
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
          reject({ success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data, response_data: response_data });
        }
        /////</end> input validation

        var params = {
          'p2s9_firebase_email': firebase_email,
          'p2s9_token': firebase_token,
          'p2s9t8_ngp_uid': ngp_uid.replace("ngp_", ""),
          'p2s9t8_rule_uid': rule_uid,
          'p2s9t8_object_uid': object_uid,
          'p2s9t8_attribute_uid': `obj_attr_${attribute_uid.split("-")[1]}`,
          'p2s9_user_uid_number': user_id
        }

        ajax({
            url: window.G_ajax_test_domain + '/web-commands/p2s9t8-unlink-notification-group-rule-from-object',
            method: 'POST',
            data: params,
            success: function (result) {
              response_data = result;
              resolve({ success: RC.general_failure, return_msg: return_msg, debug_data: debug_data, response_data: response_data});
            },
            error: function (err) {
              if (err.status == 401) {
                window.G_firebase_auth.bi5forceTokenRefresh();
              }
              return_msg += "failed to unlink notification group rule from object, error data:" + JSON.stringify(err);
              base_i3_log(G_username, G_ip, G_page_id, task_id, RC.ajax_failure, return_msg, debug_data);
              reject({ success: RC.general_failure, return_msg: return_msg, debug_data: debug_data, response_data: response_data});
            }
        })

    });
};

export default unlinkNotificationGroupRuleFromObject 



// WEBPACK FOOTER //
// ./src/watchdog_includes/json_tasks/p2s9/p2s9t8.js